export const adminEventHosts = (params: { eventId: number }) => `event:${params.eventId}`;
